import { render, staticRenderFns } from "./ProjectTypeSelectorMenu.vue?vue&type=template&id=3563ddee&"
import script from "./ProjectTypeSelectorMenu.vue?vue&type=script&lang=js&"
export * from "./ProjectTypeSelectorMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports